import { BASE_PATH } from '@/constants/config';

const STORAGE_KEY_PREFIX = 'respondent:project-task-complete:';

function storageKey(projectId: string): string {
  return `${STORAGE_KEY_PREFIX}${projectId}`;
}

/** Persist completion across the survey → /complete → project full page loads. */
export function markProjectTaskCompleteLocally(projectId: string): void {
  try {
    sessionStorage.setItem(storageKey(projectId), '1');
  } catch {
    // private mode / SSR
  }
}

/** Read and clear the one-shot flag set after completing a project task. */
export function consumeProjectTaskCompleteLocally(projectId: string): boolean {
  try {
    const key = storageKey(projectId);
    const marked = sessionStorage.getItem(key) === '1';
    if (marked) {
      sessionStorage.removeItem(key);
    }
    return marked;
  } catch {
    return false;
  }
}

export function projectDetailHref(projectId: string): string {
  return `${BASE_PATH}/participants/projects/${projectId}`;
}
